import React, { Component } from 'react';
import { connect } from 'react-redux';
import { css, StyleSheet } from 'aphrodite';
import { Paper, FontIcon } from 'material-ui';
import RaisedButton from '../../tc-ui/raised-button-with-loader';

const styles = StyleSheet.create({
  header: { backgroundColor: '#f5f5f5', padding: '0 16px', lineHeight: '48px', color: 'black', fontSize: '20px' },
  container: { padding: '0px 2px 4px 2px', marginBottom: '64px' },
});
const TaxSettings = ({
  taxSettings,
  updateSettings,
  saveSettings,
  savingSettings,
  enableTaxSettingSaveButton,
  triggerSnackBarMessage,
}) => {
  const entryStyle = {
    width: '40%',
    fontSize: '16px',
    marginTop: '8px',
  };
  return (
    <div>
      <div className={css(styles.container)}>
        <Paper style={{ marginTop: '24px', minHeight: '100px' }}>
          <div className={css(styles.header)}>Tax Setting</div>
          <br/>
          <div style={{ marginLeft: '16px' }}>
            Please enter your Tourplan tax codes &nbsp;
            <div className="flex-tc-sb" style={entryStyle}>
              Tax Inclusion:
              <input
                value={taxSettings.inclusive || ''}
                onChange={({ target: { value } }) => updateSettings({
                  taxSettings: { ...taxSettings, inclusive: value },
                  enableTaxSettingSaveButton: true,
                })}
                style={{ width: '25%', padding: '4px', height: '32px' }}
              />
            </div>
            <div className="flex-tc-sb" style={entryStyle}>
              Tax Exclusion:
              <input
                value={taxSettings.exclusive || ''}
                onChange={({ target: { value } }) => updateSettings({
                  taxSettings: { ...taxSettings, exclusive: value },
                  enableTaxSettingSaveButton: true,
                })}
                style={{ width: '25%', padding: '4px', height: '32px' }}
              />
            </div>
            <div className="flex-tc-sb" style={entryStyle}>
              Tax Exempt:
              <input
                value={taxSettings.exempt || ''}
                onChange={({ target: { value } }) => updateSettings({
                  taxSettings: { ...taxSettings, exempt: value },
                  enableTaxSettingSaveButton: true,
                })}
                style={{ width: '25%', padding: '4px', height: '32px' }}
              />
            </div>
          </div>
          <RaisedButton
            label={enableTaxSettingSaveButton ? 'Save' : 'Saved'}
            secondary
            loader={savingSettings}
            disabled={!enableTaxSettingSaveButton}
            style={{ margin: '12px 80%', width: '130px' }}
            onTouchTap={() => {
              saveSettings({ taxSettings }, { enableTaxSettingSaveButton: false })
                .catch(() => {
                  triggerSnackBarMessage('Unable to save tax settings.');
                  updateSettings({ savingTaxSettingsError: true, enableTaxSettingSaveButton: true });
                });
            }}
          />
        </Paper>
      </div>
    </div>
  );
};

const mapPropsToState = ({ integration }) => ({
  savingTaxSettingsError: integration.getIn(['settings', 'savingTaxSettingsError']),
  savingSettings: integration.getIn(['settings', 'savingSettings']),
  enableTaxSettingSaveButton: integration.getIn(['settings', 'enableTaxSettingSaveButton']),
  taxSettings: integration.getIn(['settings', 'taxSettings']) ? integration.getIn(['settings', 'taxSettings']).toJS() : {},
});

export default connect(mapPropsToState)(TaxSettings);



// WEBPACK FOOTER //
// ./src/app/components/integration/settings/tax-settings.jsx